import { render, staticRenderFns } from "./report-users.vue?vue&type=template&id=55aaca74&"
import script from "./report-users.vue?vue&type=script&lang=js&"
export * from "./report-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports